import * as shape from 'd3-shape';
var AreaChartComponent = /** @class */ (function () {
    function AreaChartComponent() {
        this.conf = {
            xAxis: false,
            yAxis: false,
            gradient: false,
            legend: false,
            showXAxisLabel: false,
            xAxisLabel: 'Days',
            showYAxisLabel: false,
            yAxisLabel: 'Issues',
            scheme: {
                domain: ['#0055ff']
            },
            curve: shape.curveBasis
        };
    }
    return AreaChartComponent;
}());
export { AreaChartComponent };
